import { ChangeDetectorRef, Component, EventEmitter, Input,NgModule,OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { GenericButtonComponent } from "../../../global/component/generic/generic-button/generic-button.component";
import { Table, TableModule, TablePageEvent } from 'primeng/table';
import { GenericTableComponent } from "../../../global/component/generic/generic-table/generic-table.component";
import { ToastModule } from "primeng/toast";
import { FilterModes, GridDisplayColumn } from '../../../global/model/SearchModel';
import { Router } from '@angular/router';
import { DonorManualDedupesService } from '../../services/donor-manual-dedupes.service';
import { MenuItem, MessageService } from 'primeng/api';
import { SelectListItem , DonorDedupeVM} from '../../models/SelectListItem';
import { SearchService } from '../../../global/services/data/search-service/searchservice';
import { DonorDedupeComponent } from '../donor-dedupe/donor-dedupe.component';
import { DedupeDonor } from '../../models/AddDonationModels';
import { Observable, Subscription } from 'rxjs';
import { DialogModule } from "primeng/dialog";
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { MainModel } from '../../../global/model/MainModel';
import Campaign from '../../../global/model/Campaign';

interface Option {
  name: string;
  value: number;
}

@Component({
  selector: 'app-donor-manual-dedupes',
  standalone: true,
  imports: [
    FormsModule,
    DropdownModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    GenericButtonComponent,
    TableModule,
    GenericTableComponent,
    ToastModule,
    DonorDedupeComponent,
    DialogModule,
    InputTextModule,
    CommonModule 
  ],
  templateUrl: './donor-manual-dedupes.component.html',
  styleUrl: './donor-manual-dedupes.component.scss'
})

export class DonorManualDedupesComponent implements OnInit  {
  @ViewChild('dt') dt: any;
  subscription: Subscription = new Subscription();
  @Output() cancelEvent = new EventEmitter<void>();
  dataObject!: Observable<unknown>;

  options: Option[] | undefined;
  columns: GridDisplayColumn[] = [];
  manualdedupes: DonorDedupeVM[] = [];
  includeCurrentDayDonors:boolean= false;
  showDonorDedupeDialog:boolean= false;
  selectedOption: Option | undefined;
  selectedGroup: number | null= null;
  selectedRowsCount:number= 0;
  selectedRows!:any[];
  dedupeDonors: DedupeDonor[] = [];
  filteredData!: any[];
  isClearEnabled = false;
 
  loading = true;
  campaignId: number =-1;
  lkpFundCodes: SelectListItem[] = [];
  lkpContributionTypes: SelectListItem[] = [];
  lkpDonationSources: SelectListItem[] = [];
  filterViewModel: { [columnName: string]: any } = {};

  toolbarActions: MenuItem[] = [];

  myExportOptions: MenuItem[] = [
    { label: 'Download CSV', icon: 'pi pi-download' },
    { label: 'Download Excel', icon: 'pi pi-file-excel' }
  ];

  bindGridColumns() {
    this.columns = [
     {
       columnName: "",
       displayColumn: "Select",
       displayColumnType: "frozenCheckbox",
       isSortable: false
     },
     {
       columnName: "donorID",
       displayColumn: "Donor ID",
       displayColumnType: "text",
       filterType: 'textfilter',
       isSortable: true,
       isFilterable: true
     },
     {
       columnName: "name",
       displayColumn: "Name",
       displayColumnType: "text",
       filterType: 'textfilter',
        isSortable: true,
        isFilterable: true
     },
     {
       columnName: "addressLine1",
       displayColumn: "Address",
       displayColumnType: "text",
       filterType: 'textfilter',
       isSortable: true,
       isFilterable: true
     },
     {
       columnName: "occupation",
       displayColumn: "Emp/Occ",
       displayColumnType: "text",
       filterType: 'textfilter',
       isSortable: true,
       isFilterable: true
     }
   ];
 }

  constructor(private donorManualDedupesService: DonorManualDedupesService,
    private router: Router,
    private searchService: SearchService,
    private cdr: ChangeDetectorRef,
    private mainModel: MainModel,
    private messageService: MessageService) {
      const c: any = this.mainModel.selectedCampaign();
      this.campaignId = parseInt(c?.campaignId);
  }

  ngOnInit() {
      this.options = [
          { name: 'FirstName/Organization -> LastName -> Email', value: 1 },
          { name: 'FirstName/Organization -> Address1 -> State', value: 2},
          { name: 'FirstName/Organization -> LastName -> Address1 -> State', value: 0 }
      ];
      this.selectedOption = this.options[0]; 
      this.loadManualDedupesGrid();
      this.subscription.add(
        this.searchService.compareDonors$.subscribe((value) => {
          if (value) {
            console.debug(`Donor's Selected: ${value}`);
            this.showDonorDedupeDialog = true;
            this.dedupeDonors = value;
          }
        }));
  
      this.subscription.add(
        this.searchService.closeCompareDonors$.subscribe((value) => {
          if (value) {
            this.showDonorDedupeDialog = false;
            this.dedupeDonors = value;
            this.loadManualDedupesGrid();
            this.selectedGroup = null;
            this.selectedRowsCount = 0;
          }
        }));
  }
 
  onOptionChange(value: any) {
    this.loadManualDedupesGrid();
  }
  
  loadManualDedupesGrid() {
  this.bindGridColumns();
  this.loading = true;

  const selectedCampaign: any = this.mainModel.selectedCampaign();
  if (!selectedCampaign) {
    this.mainModel.fetchSelectedCampaign().subscribe({
      next: (campaign: Campaign) => {
        this.mainModel.setSelectedCampaign(campaign);
        this.campaignId = campaign.campaignId;
        this.loadDedupesData();
      },
      error: (err) => {
        console.error('Failed to fetch selected campaign:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch the selected campaign. Please try again later.',
          life: 5000,
        });
        this.loading = false;
      }
    });
  } else {
    this.campaignId = selectedCampaign.campaignId;
    this.loadDedupesData(); 
  }
}

private loadDedupesData() {
  const params = {
    campaignId: this.campaignId,
    filter: parseInt(String(this.selectedOption?.value ?? '0'), 10),
    currentDay: this.includeCurrentDayDonors
  };

  this.donorManualDedupesService.GetDonorManualDedupes(params).subscribe({
    next: (data) => {
      const groupMap = new Map<number, boolean>();
      data.forEach((d) => { 
        const key = d._key_out ?? '';
        if (!groupMap.has(key)) { groupMap.set(key, false); }
      });

      this.manualdedupes = data.map((d) => ({ ...d,selected: groupMap.get(d._key_out ?? ''), disabled:false}));
      this.filteredData = [...this.manualdedupes];
      this.loading = false;
    },
    error: (err) => {
      console.error('Unable to load Donation flags. Please try again later.', err);
      this.loading = false;
    }
  });
}

  search() {
    console.debug(this.filterViewModel);
    this.loadManualDedupesGrid();
  }

  onCheckBoxGroupSelected(row: any) {
    this.selectedRowsCount= this.manualdedupes.filter(d=> d.selected).length;
    if (row.selected === true) {
      this.selectedGroup = row._key_out;
      this.manualdedupes.forEach(d => {if (d._key_in === row._key_in) {d.selected = true;}});
    }
    
    if (this.selectedRowsCount > 2) {
      this.messageService.add({
        severity: 'error',
        summary: '',
        detail: 'You can only  select maximum of 2 rows.',
      });
      row.selected= false;
      return false;
    }

    if (this.selectedRowsCount === 0){
      this.selectedGroup= null;
      this.manualdedupes.forEach(d => {d.selected = false; d.disabled = false;});
    }
   
    this.manualdedupes.forEach(d => {if (d._key_out !== row._key_out && row.selected) {d.selected = false; d.disabled = true;}});
    return true;
  }

  onCompareDonors() {
    if (this.selectedRowsCount === 2) {
      this.dedupeDonors = this.manualdedupes
      .filter(d => d.selected === true)
      .map(d => {
        return {
          DonorID: d.donorID ?? 0,
          Organization: d.organization ?? '',
          FirstName: d.firstName ?? '',
          LastName: d.lastName ?? '',
          MiddleName: d.middleName ?? '',
          Suffix: d.suffix ?? '',
          AddressLine1: d.addressLine1 ?? '',
          AddressLine2: d.addressLine2 ?? '',
          City: d.city ?? '',
          State: d.state ?? '',
          ZipCode: d.zipCode ?? '',
          HomePhone: d.homePhone ?? '',
          CellPhone: d.cellPhone ?? '',
          EmailAddress: d.emailAddress ?? '',
          Employer: d.employer ?? '',
          Occupation: d.occupation ?? '',
          OfficePhone: d.officePhone ?? ''
        };
      });

      this.searchService.emitCompareDonorsSelected(this.dedupeDonors);
    }
  }
  currentDaySelection(){
    this.loadManualDedupesGrid();
  }

  onColumnFilter(value: string, field: string): void {
    const lowerValue = value.toLowerCase();
  
    this.filteredData  = this.manualdedupes.filter(item => {
      const fieldValue = (item as any)[field];
      if (fieldValue == null) return false;
      return fieldValue.toString().toLowerCase().includes(lowerValue);
    });
  }

  checkFields(value: any) {
      if(value && value.trim() !== '')
        this.isClearEnabled = true;
      else
        this.isClearEnabled = false;
  }
  
  clearFields() {
    this.selectedRowsCount=0;
    this.loadManualDedupesGrid();
  }
}
